import { useCallback, useEffect, useRef, useState } from 'react';

export function useCopyToClipboard(resetMs = 1200) {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    },
    []
  );

  const copy = useCallback(
    (value: string | null | undefined) => {
      if (!value) return;
      navigator.clipboard
        .writeText(value)
        .then(() => {
          setCopied(true);
          if (timerRef.current) clearTimeout(timerRef.current);
          timerRef.current = setTimeout(() => setCopied(false), resetMs);
        })
        // Rejected when the document is unfocused or permission is denied —
        // leave `copied` false rather than firing an unhandled rejection.
        .catch(() => {});
    },
    [resetMs]
  );

  return { copied, copy };
}
